import React, { useState, useEffect, useContext, useRef } from 'react';
import QuoteBuilderNavSection from 'components/quote_builder/QuoteBuilderNavSection.jsx';
import QuoteBuilderForm from 'components/quote_builder/QuoteBuilderForm.jsx';
import QuoteBuilderManagePanel from 'components/quote_builder/QuoteBuilderManagePanel.jsx';

// has_many QuoteBuilderNavSections
const QuoteBuilderNavSectionList = ({ config, payload, presentedOptions, navSections }) => {

return (
  <div className="container">

      <div className="float-right" style={{ 'marginRight': '20px'}}>
          <a href="/quote-builder/settings" className="btn btn-default btn-sm no-border" target="_blank">
            [ <i className="fa fa-cog" aria-hidden="true"></i> {t('nav.quote_builder_settings_long')} ]
          </a>
      </div>
      <div style={{'clear': 'both'}} />

      <div className="container_flex" style={{ 'marginLeft': '-40px', 'marginRight': '20px'}}>

        <div className="box_flex box_flex_30">
          <QuoteBuilderForm config={config.customer} />
        </div>

        <div className="box_flex box_flex_35">
          <QuoteBuilderForm config={config.general} />
        </div>

        <div className="box_flex box_flex_35">
          <QuoteBuilderManagePanel />
        </div>
      </div>

    {navSections.map((navSection, index) => {
      return (
        <div className="row" key={`row_${index}`}>
          <QuoteBuilderNavSection
            config={config}
            payload={payload}
            presentedOptions={presentedOptions}
            key={`navSection_${index}`}
            navSection={navSection} />
         </div>
      )
    })}

</div>
);
}

export default QuoteBuilderNavSectionList;
